import * as React from "react";
import { cn } from "@/lib/utils";

export interface CardProps extends React.ComponentProps<"div"> {
  className?: string;
  children: React.ReactNode;
}

export default function Card({
  className,
  children,
  ...props
}: CardProps) {
  return (
    <div
      className={cn(
        "rounded-md border border-black bg-linear-to-b from-white to-gray-100 m-1 px-4",
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}